import { FC } from 'react'
import { ReactComponent as MailForbidIcon } from 'src/assets/svg/ri-mail-forbid-fill.svg'
import classes from './inboxAnalysisEmptyState.module.scss'

interface InboxAnalysisEmptyStateProps {
  onEnableClick: () => void
}

export const InboxAnalysisEmptyState: FC<InboxAnalysisEmptyStateProps> = ({
  onEnableClick,
}) => {
  return (
    <div className={classes.disabledContainer}>
      <div className={classes.disabledContent}>
        <MailForbidIcon className={classes.forbidIcon} />
        <h2 className={classes.disabledTitle}>Inbox Analysis is Disabled</h2>
        <p className={classes.disabledDescription}>
          Enable Inbox Analysis to connect your Facebook, Instagram, or
          <br />
          WhatsApp pages and start seeing insights on incoming messages.
        </p>
        <button
          className={classes.enableButton}
          onClick={onEnableClick}
          type="button"
        >
          Enable
        </button>
      </div>
    </div>
  )
}
